module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dropdown', {
    attrs: {
      "aria-role": "list"
    },
    model: {
      value: (_vm.isPublic),
      callback: function($$v) {
        _vm.isPublic = $$v
      },
      expression: "isPublic"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger",
      "type": "button"
    },
    slot: "trigger"
  }, [(_vm.isPublic) ? [_c('b-icon', {
    attrs: {
      "icon": "earth"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Public")])] : [_c('b-icon', {
    attrs: {
      "icon": "account-multiple"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Friends")])], _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 2), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": true,
      "aria-role": "listitem"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "earth"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v("Public")]), _vm._v(" "), _c('small', [_vm._v("Everyone can see")])])], 1)]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": false,
      "aria-role": "listitem"
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('b-icon', {
    staticClass: "media-left",
    attrs: {
      "icon": "account-multiple"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('h3', [_vm._v("Friends")]), _vm._v(" "), _c('small', [_vm._v("Only friends can see")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229fb446"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/examples/ExCustomize.vue
// module id = 1070
// module chunks = 11 134